<template>
  <!-- Link -->
  <a :href="urlPath" class="header-topbar-button" v-if="url">
    <BaseIcon tag="span" :type="iconLeft" v-if="iconLeft" class="icon-left" />
    {{ text }}
    <BaseIcon tag="span" :type="iconRight" v-if="iconRight" class="icon-right" />
  </a>
  <!-- Router-link -->
  <router-link :to="urlPath" class="footer-navbar-button" v-else>
    <BaseIcon tag="span" :type="iconLeft" v-if="iconLeft" class="icon-left" />
    {{ text }}
    <BaseIcon tag="span" :type="iconRight" v-if="iconRight" class="icon-right" />
  </router-link>
</template>

<script>
import BaseIcon from '@base/BaseIcon'

export default {
  name: 'TheHeaderTopbarButton',
  props: {
    iconLeft: {
      type: String,
      required: false
    },
    iconRight: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: false
    },
    route: {
      type: String,
      required: false
    }
  },
  components: {
    BaseIcon
  },
  computed: {
    urlPath () {
      return this.url ? this.url
        : !this.url && !this.route ? ''
          : this.route
    }
  }
}
</script>

<style lang="scss">
  .header-topbar-button{
    @include add-transition;
    @include text-color(white, white);
    @include background-color(colors("topbar"), tint(colors("topbar"), 10%));
    @include media("small-medium"){
      width: 100%;
      font-size: 1.6rem;
      padding: layout("spacing")/2 layout("spacing");
      border-bottom: 1px solid shade(colors("topbar"), 20%);
    }
    @include media("large"){
      padding: layout("spacing")/2 layout("spacing");
      border-left: 1px solid shade(colors("topbar"), 20%);
      border-right: 1px solid shade(colors("topbar"), 20%);
      font-size: 1.4rem;
    }

    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 0;

    text-transform: none;
    font-weight: font-weights("bold");

    > *{
      flex: 0 1 auto;
    }

    .icon-left{
      margin-right: 1rem;
    }

    .icon-right{
      margin-left: 1rem;
    }
  }
</style>
